import axios from 'axios'
import * as dev from '../../config/dev.env'
import store from '../store'
import Vue from 'vue'
import {
  removeToken
} from '@/utils/auth'

let api = dev.BASE_API
// 需求4456，增加是否显示招聘部门
let showZpbm = true
if (process.env.NODE_ENV === 'production') {
  let oReq = new XMLHttpRequest()
  oReq.open('get', 'serverconfig.json', false)
  oReq.send(null)
  if (oReq.status === 200) {
    api = JSON.parse(oReq.response).BASE_API
    showZpbm = JSON.parse(oReq.response).ZPBM
  }
}

global.api = api
global.showZpbm = showZpbm

const service = axios.create({
  baseURL: api,
  timeout: 30000
})

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      // 50008:非法的token; 50012:其他客户端登录了;  50000:Token 过期了;
      if (res.code === 50008 || res.code === 50012 || res.code === 50000) {
        Vue.prototype.$toast({
          type: 'error',
          content: '你已被登出',
          title: '警告'
        })
        removeToken()
        store.commit('clearToken')
        setTimeout(() => {
          window.location.href = global.api + res.data
        }, 2000)
      }
      return Promise.reject(res)
    } else {
      return response.data
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js